app.component("studentChangePhoneModalComponent", {
    templateUrl: _pb + 'student-new/change-phone-modal.html',
    controller: StudentChangePhoneModalController,
    controllerAs: 'vm',
    bindings: {
        close: '&',
        dismiss: '&'
    }
});

StudentChangePhoneModalController.$inject = ['AuthService', 'toastr'];

function StudentChangePhoneModalController(AuthService, toastr) {
    var vm = this;
    vm.step = 'phone';
    vm.phone = '';
    vm.smsCode = '';
    vm.errorTextPhone = '';
    vm.errorTextConfirmation = '';

    vm.send = function () {
        vm.errorTextPhone = '';
        if (vm.phone.length !== 9) {
            vm.errorTextPhone = 'ტელ. ნომერი უნდა შეიცავდეს 9 ციფრს.';
            return;
        }
        AuthService.requestPhoneChange({phone: vm.phone}).then(function (data) {
            if(data.status === 'ok') {
                vm.step = 'confirm';
            }
            else {
                vm.errorTextPhone = 'დაფიქსირდა ხარვეზი. გთხოვთ შეიყვანოთ ნომერი ხელახლა.';
            }
        });
    };

    vm.confirm = function () {
        vm.errorTextConfirmation = '';
        if (vm.smsCode.length !== 4) {
            vm.errorTextConfirmation = 'კოდი უნდა შეიცავდეს 4 სიმბოლოს';
            return;
        }
        AuthService.confirmPhoneChange({smsCode: vm.smsCode}).then(function (data) {
            if (data.status === 'ok') {
                AuthService.restore().then(function () {
                    toastr.success('', 'ნომერი წარმატებით შეიცვალა');
                    vm.close();
                });
            } else {
                vm.errorTextConfirmation = 'შეყვანილი კოდი არ ემთხვევა გამოგზავნილს. გთხოვთ გადაამოწმოთ';
            }
        });
    };
}
